import type { Theme } from '@mui/material';
import type { StyleExtend } from 'providers/theme/theme.types';

export const StatusToggleStyle: StyleExtend<Theme> = {
  position: 'relative',
  textTransform: 'unset',
  minHeight: '1.75rem',
  paddingBlock: '.125rem',
  border: 'none',
  color: (theme) => `${theme.palette.customColors.white50} !important`,
  borderRadius: '100px',
  width: 'fit-content',
  maxHeight: 'fit-content',
};

export const StatusToggleIconWrapperStyle: StyleExtend<Theme> = {
  lineHeight: '0',
  position: 'absolute',
  height: 'fit-content',
  margin: 'auto',
};
